async function request(name: string, input: unknown): Promise<any> {
  const response = await fetch(`/api/endpoints/${encodeURIComponent(name)}`, { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json', 'x-staff-hub-csrf': 'same-origin' }, body: JSON.stringify(input ?? {}) });
  const value = await response.json().catch(() => ({}));
  if (!response.ok) throw Object.assign(new Error(value.message || `Endpoint ${name} failed`), { code: value.code, status: response.status });
  return value;
}
export const callEndpoint = (name: string, input: unknown): Promise<any> => request(name, input);
export async function* streamEndpoint(name: string, input: unknown): AsyncGenerator<any, void, unknown> {
  const value = await request(name, input);
  for (const chunk of value.__stream || [value.text || value.answer || '']) if (chunk) yield chunk;
}
